import { FC, useMemo, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { PreviewProps } from './Preview.types';
import Button from '../../../../components/Button/Button';
import { AddOptionPage, Buttons, StyledH2, StyledP } from '../AddOption.styles';
import { Message } from '../../../../common/TwoButtonModal/TwoButtonModal.styles';
import { ModalButtons } from '../../../Extract/Extract.styles';
import { Variant } from '../../../../components/Button/Button.types';
import Modal from '../../../../components/Modal/Modal';
import { ColDef } from 'ag-grid-community';

const Preview: FC<PreviewProps> = ({ previewResponse, setStep, handleSaveClick, isLoading }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      wrapHeaderText: false,
      resizable:true,
      tooltipValueGetter: (params) => params.value,
      filter: true,
      floatingFilter: true,
      tooltipShowDelay: 0
    };
  }, []);

  return (
  <AddOptionPage>
    <StyledH2>Preview Subspecs</StyledH2>
    <StyledP>
      Subspecs to be created, based on the selected source characteristics section.
    </StyledP>
    <Table
      rowData={previewResponse}
      noRowsMessage="No new subspecs will be created - subspecs with the selected target characteristics already exist."
      columnDefs={[
        { field: 'specNo', headerName: 'SpecNo', flex: 0.8 },
        { field: 'classNo', headerName: 'Class', flex: 0.7 },
        { field: 'classDesc', headerName: 'Class Description', flex: 1.2 },
        { field: 'baseNo', headerName: 'Base', flex: 0.7 },
        { field: 'baseDesc', headerName: 'Base Description', flex: 1.4 },
        { field: 'sizeNo', headerName: 'Size', flex: 0.7 },
        { field: 'sizeDesc', headerName: 'Size Description', flex: 1.2 },
        { field: 'prodNo', headerName: 'Prod', flex: 0.7 },
        { field: 'prodDesc', headerName: 'Prod Description', flex: 1.2 },
        { field: 'optionNo', headerName: 'Option', flex: 0.7 },
        { field: 'optionDesc', headerName: 'Option Description', flex: 1.2 },
        { field: 'rawProdNo', headerName: 'Raw Product', flex: 0.7 },
        { field: 'rawProdDesc', headerName: 'Raw Product Description', flex: 1.2 },
      ]}
      showHeader
      headerTitle="Target Subspecs"
      showFooter={true}
      isSizeColumnsToFit={false}
      defaultColDef={defaultColDef}
      returnedRecords={previewResponse.length}
      height={'calc(100vh - 250px)'}
    />
    <Buttons>
      <Button label="Back" variant={Variant.Secondary} onClick={() => setStep(1)} />
      <Button label="Save" onClick={() => setModalOpen(true)} isLoading={isLoading} testId={'saveButton'} disabled={!previewResponse.length} />
    </Buttons>
    <Modal
      id='previewAddOptions'
      open={modalOpen}
      title={'Are you sure you want to add these new Subspecs?'}
      onClose={() => setModalOpen(false)}
    >
      <div>
        <Message></Message>
        <ModalButtons>
          <Button variant={Variant.Secondary} label='Cancel' onClick={() => setModalOpen(false)} />
          <Button
            variant={Variant.Primary}
            label='Save'
            onClick={handleSaveClick}
            isLoading={isLoading}
            loadingLabel='Saving...'
            testId={'confirmSaveButton'}
          />
        </ModalButtons>
      </div>
    </Modal>
  </AddOptionPage>
  );
};

export default Preview;
